import { Form } from "antd";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect } from "react";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import FormCard from "../../components/card/FormCard";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import FormItemInputTextarea from "../../components/form-item/form-item-input-textarea";
import FormButton from "../../components/FormButton";
import { useNavigate, useSearchParams } from "react-router";
import { $api } from "../../helper";
import { statusShowMock, tokenMock } from "../../helper/mock";
import { useNotify } from "../../helper/notify";

export default function AddBlogCategory() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const notify = useNotify();
  const [searchParams] = useSearchParams();
  const { setDashboardName } = useStore(useDashboardName);
  const u_id = searchParams.get("u_id");
  const detail = $api.useMutation("get", "/site-api/v1/blog/category-detail/");
  const { mutate, isPending } = $api.useMutation(
    "post",
    "/site-api/v1/blog/category/",
  );

  const update = $api.useMutation("put", "/site-api/v1/blog/category/", {});

  useEffect(() => {
    setDashboardName("ایجاد دسته بندی جدید");
    if (u_id) {
      detail.mutate({
        params: {
          query: {
            category_u_id: u_id || "",
          },
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: tokenMock,
          lang: "fa",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (u_id && detail?.data?.data) {
      Object.entries(detail.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value?.toString());
      });
    }
  }, [detail.data]);

  const onFinish = (
    values: {
      seo_description: string;
      seo_title: string;
      status: string;
      title: string;
    },
    redirect = true,
  ) => {
    if (u_id) {
      update.mutate(
        {
          body: {
            ...values,
            category_u_id: u_id ?? "",
            status: Number(values.status),
          },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/blog-category");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    } else {
      mutate(
        {
          body: { ...values, status: Number(values.status) },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            form.resetFields();
            if (redirect) {
              navigate("/blog-category");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    }
  };

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e)}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <CustomBreadcrumb
        items={[
          {
            title: "دسته بندی اخبار و مقالات",
            href: "/blog-category",
          },
          {
            title: "ایجاد دسته بندی جدید",
          },
        ]}
      />
      <FormCard
        subTitle="تعریف و تنظیمات پایه مربوط به دسته‌بندی"
        title="اطلاعات اصلی دسته‌بندی"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            name={"title"}
            rules={[
              {
                required: true,
                message: "عنوان اجباری است",
              },
            ]}
            className="col-span-1"
            label="نام دسته بندی"
            inputProps={{
              placeholder: "لطفا نام دسته بندی خود را وارد کنید.",
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            name={"status"}
            rules={[
              {
                required: true,
                message: "وضعیت اجباری است",
              },
            ]}
            label="وضعیت"
            inputProps={{
              placeholder: "لطفا وضعیت نمایش محصول خود را انتخاب کنید.",
              options: statusShowMock,
            }}
          />
        </div>
      </FormCard>
      <FormCard
        title="اطلاعات سئو"
        subTitle="بهینه‌سازی دسته‌بندی برای موتورهای جستجو"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            label="عنوان سئو"
            rules={[
              {
                required: true,
                message: "عنوان سئو اجباری است",
              },
            ]}
            name={"seo_title"}
            className="col-span-1"
            inputProps={{
              placeholder: "لطفا عنوان سئو خود را وارد کنید.",
            }}
          />
          <FormItemInputTextarea
            label="توضیحات"
            rules={[
              {
                required: true,
                message: "توضیحات اجباری است",
              },
            ]}
            name={"seo_description"}
            className="col-span-1"
            inputProps={{
              className: "resize-none!",
              rows: 4,
              placeholder: "لطفا توضیحات اضافی سئو خود را بنویسید...",
            }}
          />
        </div>
      </FormCard>
      <FormButton
        isPending={isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
